<!--  MAP IFRAME  -->

<iframe [attr.src]="dealer.google_maps_embed" class="google-map"></iframe>

<!--  END MAP IFRAME  -->
